import { EType, FrontFace } from "../FrontFace";

export enum EShapeCabinetType
{
    S1 = 0,
    S2 = 1,
    S3 = 2,
    S4 = 3,
    S11 = 4,
    S12 = 5,
    S16 = 6,
    S17 = 7,
    S18 = 8,
    S19 = 9,
    S20 = 10,
    S21 = 11,
    S22 = 12,
    S24 = 13,
    S25 = 14,
    S27 = 15,
    S51 = 16
}

export interface IShapeType {
    faces: ReadonlyArray<FrontFace>;
}

export abstract class ShapeType<TEnum> implements IShapeType {
    
    public Identifier: TEnum;
    public faces: ReadonlyArray<FrontFace>;

    constructor(
        identifier: TEnum,
        faces: EType[]
    ) {
        this.Identifier = identifier;
        this.faces = faces.map((f, i) => new FrontFace(f, i));
    }
}

export class ShapeTypeUtils {
    /**
     * Get the IShapeType corresponding to the given enum value
     * @param value Enum value of any shape type enum
     * @returns IShapeType
     */
    public static get(value: any): IShapeType | undefined {
        switch (value.constructor) {
            case EShapeCabinetType:
                return ShapeCabinetType.Get(value);
            // case EShapePanelType:
            //     return (value as EShapePanelType).get();
            // case EShapelessPanelType:
            //     return (value as EShapelessPanelType).get();
            // case EShapeCutType:
            //     return (value as EShapeCutType).get();
            default:
                throw new Error(`Unknown ShapeType enum: ${value}`);
        }
    }

    /**
     * Get the default shape type enum value
     * @param enumType Enum type
     * @returns Enum value
     */
    public static getDefaultShapeType(enumType: any): any {
        switch (enumType.name) {
            case 'EShapeCabinetType':
                return EShapeCabinetType.S1;
            // case 'EShapePanelType':
            //     return EShapePanelType.S1;
            // case 'EShapelessPanelType':
            //     return EShapelessPanelType.S1;
            // case 'EShapeCutType':
            //     return EShapeCutType.S0;
            default:
                throw new Error(`Unknown ShapeType enum type: ${enumType}`);
        }
    }
}


 /// <summary>
 /// Indicate which orientations are allowed on the shape
 /// </summary>
 export enum ESymetry
 {
     /// <summary>
     /// Only accepts S, SL and SR
     /// </summary>
     SymetricOnly,

     /// <summary>
     /// Only accept L, R, AL and AR
     /// </summary>
     AsymetricOnly,

     /// <summary>
     /// Accepts all orientations
     /// </summary>
     All,
 }


export class ShapeCabinetType extends ShapeType<EShapeCabinetType> {

    IsCorner: boolean = false;
    Symetry: ESymetry = ESymetry.SymetricOnly;

    private static _dict: Map<EShapeCabinetType, ShapeCabinetType> = new Map<EShapeCabinetType, ShapeCabinetType>();

    constructor(identifier: EShapeCabinetType, faces: EType[], isCorner: boolean, symetry: ESymetry) {
        super(identifier, faces);
        this.IsCorner = isCorner;
        this.Symetry = symetry;
    }

    static {
        ShapeCabinetType._dict = new Map<EShapeCabinetType, ShapeCabinetType>([
            [
                EShapeCabinetType.S1, 
                new ShapeCabinetType(
                    EShapeCabinetType.S1,
                    [EType.Front, EType.Right, EType.Undefined, EType.Left],
                    false,
                    ESymetry.SymetricOnly
                )
            ],
            [EShapeCabinetType.S2, new ShapeCabinetType(
                EShapeCabinetType.S2,
                [EType.Front, EType.Right, EType.Undefined, EType.Left],
                false,
                ESymetry.AsymetricOnly)
            ],
            [EShapeCabinetType.S3, new ShapeCabinetType(
                EShapeCabinetType.S3,
                [EType.Front, EType.Right, EType.Undefined, EType.Left],
                false,
                ESymetry.SymetricOnly)
            ],
            [EShapeCabinetType.S4, new ShapeCabinetType(
                EShapeCabinetType.S4,
                [EType.Front, EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Left],
                false,
                ESymetry.All)
            ],
            [EShapeCabinetType.S11, new ShapeCabinetType(
                EShapeCabinetType.S11,
                [EType.Front, EType.Right, EType.Undefined, EType.Left],
                false,
                ESymetry.AsymetricOnly)
            ],
            [EShapeCabinetType.S12, new ShapeCabinetType(
                EShapeCabinetType.S12,
                [EType.Front, EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Left],
                false,
                ESymetry.AsymetricOnly)
            ],
            [EShapeCabinetType.S16, new ShapeCabinetType(
                EShapeCabinetType.S16,
                [EType.Front, EType.Front, EType.Front, EType.Right, EType.Undefined],
                false,
                ESymetry.All)
            ],
            [EShapeCabinetType.S17, new ShapeCabinetType(
                EShapeCabinetType.S17,
                [EType.Front, EType.Front, EType.Front, EType.Right, EType.Undefined],
                false,
                ESymetry.All)
            ],
            [EShapeCabinetType.S18, new ShapeCabinetType(
                EShapeCabinetType.S18,
                [EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S19, new ShapeCabinetType(
                EShapeCabinetType.S19,
                [EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S20, new ShapeCabinetType(
                EShapeCabinetType.S20,
                [EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S21, new ShapeCabinetType(
                EShapeCabinetType.S21,
                [EType.Front, EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S22, new ShapeCabinetType(
                EShapeCabinetType.S22,
                [EType.Front, EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S24, new ShapeCabinetType(
                EShapeCabinetType.S24,
                [EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S25, new ShapeCabinetType(
                EShapeCabinetType.S25,
                [EType.Front, EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.All)
            ],
            [EShapeCabinetType.S27, new ShapeCabinetType(
                EShapeCabinetType.S27,
                [EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.AsymetricOnly)
            ],
            [EShapeCabinetType.S51, new ShapeCabinetType(
                EShapeCabinetType.S51,
                [EType.Front, EType.Right, EType.Undefined, EType.Undefined, EType.Left],
                true,
                ESymetry.AsymetricOnly)
            ]
        ]);
    }

    public static Get(value: EShapeCabinetType): ShapeCabinetType | undefined {
        return ShapeCabinetType._dict.get(value);
    }    
}